// extracted by mini-css-extract-plugin
export default {"sidebarEditor":"SidebarEditor_sidebarEditor__NvHM5"};